import { useContext } from 'react'
import { ThreadSearchContext } from './threadSearch'

export const useThreadSearch = () => useContext(ThreadSearchContext)
